var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-sidebar-wrapper" },
    [
      _c("SidebarChild", {
        attrs: {
          "default-open": true,
          "title-enabled": true,
          "selected-item": _vm.getSelectedItem(),
          tabs: _vm.getMenuTabs(),
          items: _vm.getMenuItems(),
          focusActive: true,
          "enable-non-grouped-draggable": true,
          className: "chat-menu",
        },
        on: {
          selected: _vm.selectedItem,
          contextmenu: _vm.handleContextMenu,
          dragEnd: _vm.handleDragEnd,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "sidebar-title-text" }, [
                  _vm._v(_vm._s(_vm.$t("chat.inbox"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sidebar-title-actions" },
                  [
                    _c(
                      "Tooltip",
                      { attrs: { title: _vm.$t("chat.sidebar.tabScreen") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sidebar-title-action",
                            on: { click: _vm.openTabScreen },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("backup_table"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "Tooltip",
                      { attrs: { title: _vm.$t("chat.sidebar.search") } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sidebar-title-action",
                            on: { click: _vm.search },
                          },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("search"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "Views-empty",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "empty-group-item",
                    on: { click: _vm.addNewFilter },
                  },
                  [
                    _c("div", { staticClass: "empty-group-item-icon" }, [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("add_circle_outline"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "empty-group-item-content" }, [
                      _c("div", { staticClass: "empty-group-item-text" }, [
                        _vm._v(_vm._s(_vm.$t("chat.sidebar.addNewFilter"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.contextMenuVisible
        ? _c(
            "div",
            {
              staticClass: "inbox-context-menu",
              style: {
                left: _vm.contextMenuX + "px",
                top: _vm.contextMenuY + "px",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleEdit },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("edit")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("chat.sidebar.edit")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleOpenInTable },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("table_chart"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.showInTable"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleOpenInKanban },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("view_kanban"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.showInKanban"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isCustomFilter
                ? [
                    _c("div", { staticClass: "context-menu-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item",
                        on: { click: _vm.handleRename },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("drive_file_rename_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chat.sidebar.rename"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item",
                        on: { click: _vm.handleToggleVisibility },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$_.get(_vm.selectedFilter, "visibility") ===
                                "private"
                                ? "lock_open"
                                : "lock"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$_.get(_vm.selectedFilter, "visibility") ===
                                "private"
                                ? _vm.$t("chat.sidebar.makePublic")
                                : _vm.$t("chat.sidebar.makePrivate")
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "context-menu-divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleMoveToTop },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("vertical_align_top"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.moveToTop"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleMoveToBottom },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("vertical_align_bottom"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("chat.sidebar.moveToBottom"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isCustomFilter
                ? [
                    _c("div", { staticClass: "context-menu-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "context-menu-item danger",
                        on: { click: _vm.handleDelete },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("chat.sidebar.delete"))),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("chat.sidebar.renameFilterTitle") },
          on: {
            ok: _vm.handleRenameSubmit,
            cancel: function ($event) {
              _vm.renameModalVisible = false
            },
          },
          model: {
            value: _vm.renameModalVisible,
            callback: function ($$v) {
              _vm.renameModalVisible = $$v
            },
            expression: "renameModalVisible",
          },
        },
        [
          _c("a-input", {
            attrs: {
              placeholder: _vm.$t("chat.sidebar.filterNamePlaceholder"),
            },
            on: { pressEnter: _vm.handleRenameSubmit },
            model: {
              value: _vm.renameValue,
              callback: function ($$v) {
                _vm.renameValue = $$v
              },
              expression: "renameValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }